import backup from './fallback/en.json';
import development from './development/en.json';
const merge = require('deepmerge');

export default async ({ $axios, $config }) => {
    let data = {};

    await $axios.$get(`${$config.baseURL}/api/en/translate`).then((res) => {
        if (res.success === 1) {
            data = res.data;
        }
    });

    return merge(merge(backup, data), development);
};
